module.exports = __webpack_public_path__ + "img/zgjrrz.28e56f3f.jpg";